import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'
import _imports_1 from '@/assets/images/file_big_icon.png'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "file-upload-popup" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup_title" }
const _hoisted_5 = { class: "popup-body" }
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","align-items":"center","gap":"10px"}
}
const _hoisted_7 = ["readonly"]
const _hoisted_8 = {
  key: 1,
  class: "popup_desc"
}
const _hoisted_9 = {
  key: 2,
  class: "popup_desc"
}
const _hoisted_10 = {
  key: 0,
  style: {}
}
const _hoisted_11 = {
  key: 1,
  src: _imports_1
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["accept"]
const _hoisted_17 = { class: "popup-footer" }

import { ref, onMounted } from "vue";
import userAPI from "@/api/userAPI";

// Props 정의: 요청파일정보를 객체로 처리

export default /*@__PURE__*/_defineComponent({
  __name: 'UserFileUploadPop',
  props: {
    등록구분: {},
    도장구분: {},
    oldSeq: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const img = ref('')
const sealPwdFlag = ref(false)
onMounted(async() => {
  if(props.도장구분 !== '인감') {
    getSeal()
  }
})

const getSeal = async() => {
  if (props.등록구분 === '도장' && props.도장구분 === '사용인감' && props.oldSeq) {
    const res = await userAPI.sealFile(props.oldSeq, props.도장구분, '');
    const blob = new Blob([res.data], { type: 'image/jpeg' });
    img.value = URL.createObjectURL(blob);
  } else if(props.등록구분 === '도장' && props.도장구분 === '인감') {
    await userAPI.sealCheck(sealPassword.value).then(async(res) => {
      if(res.data.data) {
        sealPwdFlag.value = true
        const res = await userAPI.sealFile(props.oldSeq, props.도장구분!, sealPassword.value);
        const blob = new Blob([res.data], { type: 'image/jpeg' });
        img.value = URL.createObjectURL(blob);
      }
    })
  }
}
const pwdChk = () => {
  if(props.도장구분 === '인감' && !sealPwdFlag.value) {
    alert('인감 비밀번호를 입력해주세요.')
    return
  }
  if (fileInp.value) {
    fileInp.value.click()
  }
}
// HTMLInputElement 타입을 명시적으로 지정
const fileInp = ref<HTMLInputElement>();

// Param 인터페이스 정의하여 param 타입 지정
// file1 타입을 File | null로 지정
const file1 = ref<File | null>(null);

const onDragOver = (event: DragEvent) => {
  event.preventDefault()
  ;(event.currentTarget as HTMLElement).classList.add('active')
  event.dataTransfer!.dropEffect = 'copy'
}
const onDragLeave = (event: DragEvent) => {
  (event.currentTarget as HTMLElement).classList.remove('active')
  event.preventDefault()
}

const onDrop = (event: DragEvent) => {
  if(props.도장구분 === '인감' && !sealPwdFlag.value) {
    alert('인감 비밀번호를 입력해주세요.')
    return
  }
  event.preventDefault()
  const files = event.dataTransfer!.files
  if (files.length > 0) {
    upload(files[0])
  }
}
const sealPassword = ref('')
const upload = (filedata: File) => {
  if (filedata === undefined) return

  for (let i = 0; i < document.getElementsByClassName('drop-zone').length; i++) {
    document.getElementsByClassName('drop-zone')[i].classList.remove('active')
  }
  if (filedata && filedata.size > 10 * 1024 * 1024) {
    alert('파일 크기는 10MB를 초과할 수 없습니다.')
    return
  }
  // 도장인 경우 이미지 파일 타입 검증 추가
  if (props.등록구분 == '도장' && !filedata.type.startsWith('image/')) {
    alert("도장은 이미지 파일만 업로드 가능합니다.");
    return;
  }
  if (props.등록구분 != '도장' && !(filedata.type.startsWith('image/') || filedata.type === 'application/pdf')) {
    alert("이미지 또는 PDF 파일만 업로드 가능합니다.");
    return;
  }
  file1.value = filedata
  
  if (filedata && filedata.type.startsWith('image/')) {
    img.value = URL.createObjectURL(filedata);
  }
    
}
// 파일 업로드 처리
const addFile = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0] || null;
  file1.value = file;
  
  // 도장인 경우 이미지 파일 타입 검증
  if (props.등록구분 == '도장' && file && !file.type.startsWith('image/')) {
    alert("도장은 이미지 파일만 업로드 가능합니다.");
    return;
  }
  
  if (props.등록구분 != '도장' && file && !(file.type.startsWith('image/') || file.type === 'application/pdf')) {
    alert("이미지 또는 PDF 파일만 업로드 가능합니다.");
    return;
  }
  file1.value = file;
  // 이미지 미리보기 생성
  if (file && file.type.startsWith('image/')) {
    img.value = URL.createObjectURL(file);
  }
};

const uploadFile = () => {
  if (!file1.value) {
    alert("파일을 첨부해주세요.");
    return;
  }
  // 도장인 경우 이미지 파일 타입 최종 검증
  if (props.등록구분 == '도장' && !file1.value.type.startsWith('image/')) {
    alert("도장은 이미지 파일만 업로드 가능합니다.");
    return;
  }
  // 도장이 아닌 경우 이미지 또는 PDF 파일 타입 검증
  if (props.등록구분 != '도장' && 
      !(file1.value.type.startsWith('image/') || file1.value.type === 'application/pdf')) {
    alert("이미지 또는 PDF 파일만 업로드 가능합니다.");
    return;
  }
  const fileParam = {
    등록구분: props.등록구분,
    도장구분: props.도장구분,
    인감비밀번호: sealPassword.value
  }
  if (props.도장구분 === '인감' && sealPassword.value === '') {
    alert('인감 비밀번호를 입력해주세요.')
    return
  }
  userAPI
    .uploadUserFile(fileParam, file1.value)
    .then((res) => {
      alert('파일이 등록되었습니다.')
      sealPassword.value = ''
      emit("closePopup", { popupType: "fileUpload", refresh:true });
    })
};
// 팝업 닫기 처리
function closePopup(refresh: boolean) {
  emit("closePopup", { popupType: "fileUpload", refresh: false });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "popup_cover" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.등록구분 == '도장' ? props.도장구분 : props.등록구분) + " 등록", 1),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closePopup(false))),
          class: "close_icon"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (props.도장구분 == '인감')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sealPassword).value = $event)),
                placeholder: "비밀번호 입력",
                onKeyup: _withKeys(getSeal, ["enter"]),
                readonly: sealPwdFlag.value
              }, null, 40, _hoisted_7), [
                [_vModelText, sealPassword.value]
              ]),
              (!sealPwdFlag.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "pwd_chk_btn",
                    onClick: getSeal
                  }, "확인"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (props.등록구분 == '도장')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[5] || (_cache[5] = [
              _createTextVNode(" 아래 박스 클릭 또는 마우스로 끌어오기 해주세요. "),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("span", { class: "file-type-hint" }, "(JPG, PNG 등 이미지 파일만 가능)", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[6] || (_cache[6] = [
              _createTextVNode(" 아래 박스 클릭 또는 마우스로 끌어오기 해주세요. "),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("span", { class: "file-type-hint" }, "(JPG, PNG 등 이미지 또는 PDF 파일만 가능)", -1)
            ]))),
        _createElementVNode("div", {
          class: "file_upload_area",
          onDragover: _withModifiers(onDragOver, ["prevent"]),
          onDragleave: _withModifiers(onDragLeave, ["prevent"]),
          onDrop: _withModifiers(onDrop, ["prevent"]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (pwdChk()))
        }, [
          (file1.value === null && !img.value)
            ? (_openBlock(), _createElementBlock("label", _hoisted_10, "파일 첨부 +"))
            : _createCommentVNode("", true),
          (file1.value !== null && props.등록구분 == '사업자등록증')
            ? (_openBlock(), _createElementBlock("img", _hoisted_11))
            : _createCommentVNode("", true),
          (file1.value === null && !img.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[7] || (_cache[7] = [
                _createTextVNode("또는"),
                _createElementVNode("br", null, null, -1),
                _createTextVNode("파일놓기")
              ])))
            : _createCommentVNode("", true),
          (file1.value !== null && props.등록구분 == '사업자등록증')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(file1.value?.name), 1))
            : _createCommentVNode("", true),
          (_ctx.oldSeq && img.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("img", { src: img.value }, null, 8, _hoisted_15)
              ]))
            : _createCommentVNode("", true),
          _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1))
        ], 32),
        _createElementVNode("input", {
          ref_key: "fileInp",
          ref: fileInp,
          class: "file_inp",
          type: "file",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (addFile($event))),
          accept: props.등록구분 == '도장' ? 'image/*' : '.pdf, image/*'
        }, null, 40, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: "popup_close_btn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (closePopup(false)))
        }, "취소"),
        _createElementVNode("div", {
          class: "popup_confirm_btn",
          onClick: uploadFile
        }, "등록")
      ])
    ])
  ]))
}
}

})